module.exports = "/_next/static/images/img__teachers_left_top_desktop-93bc4ce83efaa9ea9606f261f63dd7e0.png";